import { FieldModel, ProgramBenchmarkName, ProgramTask, TaskDataTraitStatus } from '@cibo/core'
import { LivestockCellDisplay } from '@cibo/landmanager'
import { TraitCellContainer } from './TraitCellContainer'

interface LivestockCellProps {
  value: any
  task: ProgramTask<{ benchmarkName: ProgramBenchmarkName; traits: TaskDataTraitStatus[] }>
  year: number
  selectedField?: FieldModel
  onSaveSuccess?: () => void
}

export const LivestockCell = ({
  value,
  task,
  year,
  selectedField,
  onSaveSuccess,
}: LivestockCellProps) => {
  return (
    <TraitCellContainer
      value={value}
      task={task}
      selectedField={selectedField}
      year={year}
      traitId="livestock"
      onSaveSuccess={onSaveSuccess}
    >
      <LivestockCellDisplay value={value} />
    </TraitCellContainer>
  )
}
